module.exports = __webpack_public_path__ + "static/media/hedgefund.7b08158b.jpg";